var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700003 11.625C0.500003 11.425 0.404169 11.1875 0.412503 10.9125C0.420836 10.6375 0.516669 10.4083 0.700003 10.225L5.975 4.87495C6.35834 4.49162 6.83334 4.29995 7.4 4.29995C7.96667 4.29995 8.44167 4.49162 8.825 4.87495L11.4 7.47495L16.6 2.32495H15C14.7167 2.32495 14.4792 2.22912 14.2875 2.03745C14.0958 1.84578 14 1.60828 14 1.32495C14 1.04162 14.0958 0.804118 14.2875 0.612451C14.4792 0.420785 14.7167 0.324951 15 0.324951H19C19.2833 0.324951 19.5208 0.420785 19.7125 0.612451C19.9042 0.804118 20 1.04162 20 1.32495V5.32495C20 5.60828 19.9042 5.84578 19.7125 6.03745C19.5208 6.22912 19.2833 6.32495 19 6.32495C18.7167 6.32495 18.4792 6.22912 18.2875 6.03745C18.0958 5.84578 18 5.60828 18 5.32495V3.72495L12.825 8.89995C12.4417 9.28328 11.9667 9.47495 11.4 9.47495C10.8333 9.47495 10.3583 9.28328 9.975 8.89995L7.4 6.32495L2.1 11.625C1.91667 11.8083 1.68334 11.9 1.4 11.9C1.11667 11.9 0.883336 11.8083 0.700003 11.625Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending_up.b1b0cc5fb858d4afaae4306976522de4.svg";
export { ForwardRef as ReactComponent };